import { render, staticRenderFns } from "./PerformanceGraph.vue?vue&type=template&id=fd4a7614"
import script from "./PerformanceGraph.vue?vue&type=script&lang=js"
export * from "./PerformanceGraph.vue?vue&type=script&lang=js"
import style0 from "./PerformanceGraph.vue?vue&type=style&index=0&id=fd4a7614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports